import { Theme, devuiLightTheme } from 'devui-theme';
import { colorMap, fontMap, borderMap, radiusMap, zIndexMap } from './gitcodeColorMap';
export const gitCodeTheme: Theme = new Theme({
  id: 'gitcode-theme',
  name: 'gitcode-theme',
  cnName: 'GitCode主题',
  data: Object.assign({}, devuiLightTheme.data, colorMap, fontMap, borderMap, radiusMap, zIndexMap),
  isDark: false
});
